import React from 'react';
import { Translate } from 'react-localize-redux';

import TooltipButton from '../TooltipButton';

const IsRequiredField = () => (
  <TooltipButton content={<Translate id="common.isRequired" />}>
    <span className="is-required">*</span>
  </TooltipButton>
);

export default IsRequiredField;
